import { orderDateFilterBy } from './order-date';
import { statusFilterBy, statusCriteriaArguments } from './status';
import { supplierFilterBy, supplierCriteriaArguments } from './supplier';
import { warehouseFilterBy, warehouseCriteriaArguments } from './warehouse';

export const allFilterBys = [supplierFilterBy, warehouseFilterBy, statusFilterBy, orderDateFilterBy];

export const criteriaArgumentsMap = {
  [statusFilterBy.id]: statusCriteriaArguments,
  [warehouseFilterBy.id]: warehouseCriteriaArguments,
  [supplierFilterBy.id]: supplierCriteriaArguments,
};
